export default __webpack_public_path__ + "static/media/profile-img.4162f062.png";